import React, { Component } from "react";

import { ThemeContext, themes } from "./theme-context";
import { LocalizationContext, strings } from "./localization-context";
import { RazerSkillContext, razerSkill } from "./razerskill-context";
import AppString from "settings/AlexaAppContext.json";
import TestArea from "./utils/TestArea";
import "./App.css";

import NotLogin from "./pages/state/NotLogin";
import LoggedIn from "./pages/state/LoggedIn";
import AVS from "./lib/AVS";
import AVSWrapper from "./utils/AVSWrapper";
import { AlexaCommon, retryOperation } from "./utils/Common";
import { SynapseMessenger } from "./pages/Synapse";
import EventService from "./utils/EventService";
import packageJson from "../package.json";
import hotkeys from "hotkeys-js";
hotkeys("ctrl+a", function (event, handler) {
  // Prevent the default refresh event under WINDOWS system
  event.preventDefault();
});
const autoBind = require("auto-bind");

class App extends Component {
  constructor(props) {
    super(props);

    this.avs = new AVS({
      debug: true,
      clientId: window.clientId,
      deviceId: "test_device123",
      deviceSerialNumber: 1234,
      redirectUri: `https://${window.location.host}/authresponse`,
      token: localStorage.getItem("token"),
      refreshToken: localStorage.getItem("refresh_token"),
    });

    this.state = {
      isPageBusy: true,
      theme: themes.dark,
      localization: strings,
      isSynapseGuestLoggedIn: false,
      isAccountLinkConflicts: false,
    };

    window.avs = this.avs;
    window.rzevent = EventService;
    SynapseMessenger.Initialize();
    //let wpf know wrapper is ready.
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.REQUEST_WRAPPER_IS_READY
    );
    window.SynapseMessenger = SynapseMessenger;
    this.avsWrapper = new AVSWrapper(this.avs);
    window.avsWrapper = this.avsWrapper;
    document.documentElement.setAttribute("data-theme", "dark");
    autoBind(this);
  }

  //after dom intialized.
  componentDidMount() {
    //1. Add global listener.
    this.subscribeEvents();
    //Token
    //this.authAndSetUpMicByToken()
    //2. process current URL by method of receiving code.
    let that = this;
    this.authAndSetUpMicByCode().then(() => {
      //  that.isPageBusy = false;
      that.setState({ isPageBusy: false });
    });
    //3.print app version
    console.log(
      `%c App version: ${packageJson.version}`,
      "color: #44d62c;font-size:20px"
    );
    console.log(
      `%c Endpoint string version: ${process.env.REACT_APP_ENDPOINT}`,
      "color: #31c4f3;font-size:20px"
    );
    //4. init app with Synapse data (request current synapse theme and language)
    AlexaCommon.consoleLogDataUIImportantInfo(
      "UI Event Triggered",
      window.rzevent.EventTypes.REQUEST_THEME
    );
    window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_THEME);
    window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_LANGUAGE);
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.REQUEST_SYNAPSE_TOKEN
    );
  }
  subscribeEvents() {
    //detect synapse theme change.
    var that = this;
    // window.rzevent.listenEvent(window.rzevent.EventTypes.RESPONSE_THEME_CHANGE, "1", (data = {}) => this.onSynapseThemeChange.bind(this, data));
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_THEME_CHANGE,
      "1",
      (data = {}) => {
        that.onSynapseThemeChange(data);
      }
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_LANGUAGE_CHANGE,
      "1",
      (data = {}) => {
        that.onSynapseLanguageChange(data);
      }
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_SYNAPSE_TOKEN,
      "1",
      (data = "") => {
        that.onSynapseTokenChange(data);
      }
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.SYNAPSE_ISGUEST_CHANGE,
      "1",
      (data = "") => {
        that.onSynapseIsGuestStatusChange(data);
      }
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.ACCOUNT_LINK_CONFLICTS_NOTIFICATION,
      "1",
      (data = "") => {
        that.onAccountLinkConflictsNotification(data);
      }
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_CLOSE_ALL_DIALOG,
      "1",
      (data = "") => {
        that.onResponseWPFCloseAllDialogCommand();
      }
    );
  }
  /**
   * @param {Number} data
   * @example
   * Lifestyle = 1,
   * Dark = 2
   */
  onSynapseThemeChange(data) {
    if (data === 1) {
      this.setState(
        {
          theme: themes.light,
        },
        () => {
          AlexaCommon.changeGlobalTheme("light");
        }
      );
    } else {
      this.setState(
        {
          theme: themes.dark,
        },
        () => {
          AlexaCommon.changeGlobalTheme("dark");
        }
      );
    }
  }

  /**
   *
   * @param {Number} data
   * @example
   * Undefined = 0,
   * English = 1,
   * Chinese_Simplified = 2,
   * Chinese_Traditional = 3,
   * French = 4,
   * Korean = 5,
   * Japanese = 6,
   * German = 7,
   * Russian = 8,
   * Spanish = 9,
   * Portuguese = 10
   */
  onSynapseLanguageChange(data) {
    console.log(data);
    switch (data) {
      case 0:
      case 1:
        strings.setLanguage(AppString.en_US);
        break;
      case 2:
        strings.setLanguage(AppString.zh_CHS);
        break;
      case 3:
        strings.setLanguage(AppString.zh_CHT);
        break;
      case 4:
        strings.setLanguage(AppString.fr_FR);
        break;
      case 5:
        strings.setLanguage(AppString.ko_KR);
        break;
      case 6:
        strings.setLanguage(AppString.ja_JP);
        break;
      case 7:
        strings.setLanguage(AppString.de_DE);
        break;
      case 8:
        strings.setLanguage(AppString.ru_RU);
        break;
      case 9:
        strings.setLanguage(AppString.es_ES);
        break;
      case 10:
        strings.setLanguage(AppString.pt_BR);
        break;
    }
    this.setState({ localization: strings });
  }

  /**
   * @description
   * when synapse token was sent from wpf.
   * do doAccountLinkingSteps again when current app is logged in only.
   * @function this.getRazerCodeAndTopic()
   * @param {string} razerToken
   */
  onSynapseTokenChange(razerToken) {
    //currently do nothing. wrapper is already helped to update localstorage.
  }
  /**
   *
   * @param {boolean} status
   * @description Synapse 3 user login status change will trigger this change.
   */
  onSynapseIsGuestStatusChange(status) {
    this.setState({ isSynapseGuestLoggedIn: status });
  }

  /**
   * @description
   * when current amazon log in was already linked to another razer Id.
   */
  onAccountLinkConflictsNotification(amazonId) {
    localStorage.setItem("razerAmazonId", amazonId);
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.REQUEST_SHOW_ACCOUNT_LINK_CONFLICTS_DIALOG
    );
    this.setState({ isAccountLinkConflicts: true });
  }

  onAccountLinkConflictsNotificationClose(cb = () => {}) {
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.REQUEST_CLOSE_ACCOUNT_LINK_CONFLICTS_DIALOG
    );
    this.setState({ isAccountLinkConflicts: false }, () => {
      cb();
    });
  }

  onResponseWPFCloseAllDialogCommand() {
    this.setState({ isAccountLinkConflicts: false });
  }

  /**
   * Case 1: no code in URL, no access_token in localStorage (Fresh new user)
   * Case 2: no code in URL, has access_token in localStorage.
   * Case 3: has code in URL, code is new/valid , ask for new access_token and update in localStorage.
   * Case 4: has code in URL, code is old/invalid(can be used only one time) , has access_token in localStorage.
   * Case 5: has code in URL , code is old/invalid, has no access_token in localStorage.
   * Case 6: unknown issue, should not happen.
   */
  authAndSetUpMicByCode() {
    let that = this;

    return new Promise((resolve, reject) => {
      that.avs
        .getCodeFromUrl()
        .then((code) => {
          if (localStorage.getItem("token")) {
            that.onLoginSuccess();
            //#Case 4#
            console.log("case 4 is executed");
            window.location.href = "/";
            resolve();
          }
          AlexaCommon.getTokenFromCode(code)
            .then((tokenObj) => {
              //set token
              localStorage.setItem("token", tokenObj.access_token);

              that.avs
                .setToken(tokenObj.access_token)
                .then(() => {
                  that.avs.emit(AVS.EventTypes.TOKEN_SET);
                  //set refresh_token
                  localStorage.setItem("refreshToken", tokenObj.refresh_token);

                  that.avs
                    .setRefreshToken(tokenObj.refresh_token)
                    .then(() => {
                      that.avs.emit(AVS.EventTypes.REFRESH_TOKEN_SET);
                      //init mic
                      that.setState({
                        accessToken: tokenObj.access_token,
                      });
                      if (localStorage.getItem("token")) {
                        window.avs.emit(AVS.EventTypes.LOGIN);
                      }
                      //#Case 3#
                      console.log("case 3 is executed");
                      that.onLoginSuccess();
                      resolve();
                    })
                    .catch(() => {
                      //#Case 6#
                      console.log("case 6 is executed");
                      resolve();
                    });
                })
                .catch(() => {
                  //#Case 6#
                  console.log("case 6 is executed");
                  resolve();
                });
            })
            .catch(() => {
              that.avs.emit(AVS.EventTypes.CODE_INVALID);
              //#Case 5#
              window.location.href = "/";
              console.log("case 5 is executed");
              resolve();
            });
        })
        .catch((reason) => {
          //current url doens't have a code value.
          //#Case 2#
          if (localStorage.getItem("token")) {
            //init mic
            console.log("case 2 is executed");
            that.onLoginSuccess();
          }
          console.log("case 1 is executed");
          //#Case 1#
          resolve();
        })
        .finally(() => {});
    });
  }

  /**
 * @example
  {
    "accountLinkingResponse": {
      "accessTokenScheme": "HTTP_BASIC",
      "accessTokenUrl": "https://oauth2.razer.com/token",
      "authorizationUrl": "https://oauth2.razer.com/authorize_openid",
      "clientId": "openid37e9f8c5678cdc36116db11c5d2b297934",
      "domains": [],
      "scopes": [
          "cop"
      ],
      "skipOnEnablement": false,
      "type": "AUTH_CODE"
  }
  }
  @see https://developer.amazon.com/docs/smapi/account-linking-operations.html    
  @description
  retrieve the status of current logged in amazon account.
  @returns {boolean} 
 */
  async doAccountLinkingSteps() {
    let razerToken = localStorage.getItem("synapseToken");
    let token = localStorage.getItem("token");

    if (!razerToken || !token) {
      AlexaCommon.consoleLogDataUIFatalError(
        "synapse token is not received",
        razerToken + " token is " + token
      );
      return;
    }
    let code = null;
    try {
      code = await AlexaCommon.getRazerCodeAndTopic(razerToken);
    } catch {
      console.log("getRazerCodeAndTopic failed");
      return;
    }

    let endpoint = null;
    try {
      endpoint = await AlexaCommon.getAccountLinkingEndpointForUser();
    } catch (err) {
      AlexaCommon.consoleLogDataUIFatalError(
        "getAccountLinkingEndpointForUser rejected",
        JSON.stringify(err)
      );
      return;
    }

    const setAccountLinkingStatus = async (code, endpoint) => {
      try {
        await retryOperation(() =>
          AlexaCommon.setAccountLinkingStatus(code, endpoint)
        );
        await this.SetUpPubSubServer(razerToken, endpoint);
        console.log("pubsub server details sent to client");
      } catch (err) {
        console.log("setAccountLinkingStatus failed");
      }
    };

    return setAccountLinkingStatus(code, endpoint);
  }

  SetUpPubSubServer(razerToken, endpoint) {
    return new Promise((resolve, reject) => {
      AlexaCommon.retrieveAccountLinkingStatus(endpoint)
        .then((data) => {
          if (!data) {
            AlexaCommon.consoleLogDataUIFatalError(
              "retrieveAccountLinkingStatus didn't get expected data",
              JSON.stringify(data)
            );
            reject();
          }
          if (data.data.user && data.data.user.id) {
            AlexaCommon.consoleLogDataUIImportantInfo(
              "Get razerAmazonId:",
              data.data.user.id
            );
            //Let WPF know amazonRazerId
            window.rzevent.triggerEvent(
              window.rzevent.EventTypes.REQUEST_AMAZON_ID_FOR_SYNAPSE,
              data.data.user.id
            );
            AlexaCommon.checkAmazonRazerIdAccountLinking(
              data.data.user.id,
              razerToken
            )
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
          } else {
            AlexaCommon.consoleLogDataUIFatalError(
              "retrieveAccountLinkingStatus didn't set expected data",
              JSON.stringify(data)
            );
            reject();
          }
        })
        .catch(() => {
          AlexaCommon.consoleLogDataUIFatalError(
            "retrieveAccountLinkingStatus didn't set expected data"
          );
          reject();
        });
    });
  }

  /**
   * @description
   * call this method for every success login includes use token.
   */
  onLoginSuccess() {
    if (window.location.href.indexOf("?page=") >= 0) {
      return;
    }
    console.log(
      "onLoginSuccess started in window:" + JSON.stringify(window.location.href)
    );
    this.doAccountLinkingSteps();
    this.avs.emit(AVS.EventTypes.AUTHENTICATED_SUCCESS); //start pubsub here
    console.log("onLoginSuccess completed");
  }

  render() {
    let component = "";
    if (!this.state.isPageBusy) {
      if (
        typeof localStorage.getItem("token") !== "undefined" &&
        localStorage.getItem("token") !== "undefined" &&
        localStorage.getItem("token") !== null
      ) {
        component = (
          <RazerSkillContext.Provider value={razerSkill}>
            <LoggedIn
              avsWrapper={this.avsWrapper}
              isAccountLinkConflicts={this.state.isAccountLinkConflicts}
              handleAccountLinkConflictsNotificationClose={
                this.onAccountLinkConflictsNotificationClose
              }
            />
          </RazerSkillContext.Provider>
        );
      } else {
        component = (
          <NotLogin
            avsWrapper={this.avsWrapper}
            isSynapseGuestLoggedIn={this.state.isSynapseGuestLoggedIn}
          />
        );
      }
    }
    console.log(this.state.isSynapseGuestLoggedIn);

    let overylay = this.state.isAccountLinkConflicts ? (
      <div className="rz-overlay"></div>
    ) : (
      ""
    );
    let testarea = "";
    if (process.env.NODE_ENV === "development") {
      testarea = <TestArea avsWrapper={this.avsWrapper}></TestArea>;
    }

    //#endregion
    return (
      <ThemeContext.Provider value={this.state.theme}>
        <LocalizationContext.Provider value={this.state.localization}>
          {overylay}
          <div className="App">
            {component}
            {/* {testarea} */}
          </div>
        </LocalizationContext.Provider>
      </ThemeContext.Provider>
    );
  }
}

export default App;
